'use strict';

exports.SELECT_HISTORY = 'SELECT_HISTORY';
exports.UPLOAD_HISTORY = 'UPLOAD_HISTORY';
function selectHistory(number) {
    return {
        type: exports.SELECT_HISTORY,
        payload: number,
        meta: 'SKIP_HISTORY_TRACKING'
    };
}
exports.selectHistory = selectHistory;
;
function uploadHistory(history) {
    return {
        type: exports.UPLOAD_HISTORY,
        payload: history,
        meta: 'SKIP_HISTORY_TRACKING'
    };
}
exports.uploadHistory = uploadHistory;
;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-state-history/lib/Actions.js
 ** module id = 544
 ** module chunks = 0
 **/